import React from 'react';
import PropTypes from 'prop-types';
import MultiFileUpload from './components/multi-file.component';
import SingleFileUpload from './components/single-file.component';

const CybsFileUpload = ({
  accept,
  customCSS,
  dataTest,
  fileValidation,
  label,
  multiple,
  onRetrieveFiles,
  ...buttonProps
}) => (
  <>
    {multiple ? (
      <MultiFileUpload
        dataTest={dataTest}
        accept={accept}
        onRetrieveFiles={onRetrieveFiles}
        label={label}
        fileValidation={fileValidation}
        {...buttonProps}
      />
    ) : (
      <SingleFileUpload
        customCSS={customCSS}
        dataTest={dataTest}
        accept={accept}
        onRetrieveFiles={onRetrieveFiles}
        label={label}
        {...buttonProps}
      />
    )}
  </>
);
CybsFileUpload.displayName = 'CybsFileUpload';

CybsFileUpload.propTypes = {
  /**
   * String with a pattern to be fulfilled by the files
   */
  accept: PropTypes.string,
  /**
   * Specified the color scheme used in the buttons
   */
  colorScheme: PropTypes.oneOf(['default', 'primary', 'secondary', 'tertiary']),
  /**
   * Styling function to allow CSS overrides via Emotion
   *
   * @ignore
   */
  customCSS: PropTypes.func,
  /**
   * Datatest string for testing purposes
   */
  dataTest: PropTypes.string.isRequired,
  /**
   * Function to validate the file input
   */
  fileValidation: PropTypes.func,
  /**
   * Level of the heading displayed before the component
   */
  headingLevel: PropTypes.number,
  /**
   * Text to be displayed as component label
   */
  label: PropTypes.string,
  /**
   * Indicate if multiple files will be accepted
   */
  multiple: PropTypes.bool,
  /**
   * Function to be executed when the files are retrieved by the browser
   */
  onRetrieveFiles: PropTypes.func.isRequired
};

CybsFileUpload.defaultProps = {
  accept: '*',
  colorScheme: 'primary',
  customCSS: undefined,
  fileValidation: () => true,
  headingLevel: 3,
  label: '',
  multiple: false
};

export default CybsFileUpload;
